export const ALL_FILTER_OPTION = 'All'
export const EMPTY_STATE_STRING = '--'
export const TABLE_EMPTY_STATE = 'No records to display'
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL
